import { ref } from 'vue';

export function useClipboard() {
    const copied = ref(false);
    const error = ref(null);

    const copyToClipboard = async (text) => {
        try {
            // Modern Clipboard API
            if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(text);
                return markCopied();
            }

            // Fallback for HTTP
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            textarea.style.left = '-9999px';
            document.body.appendChild(textarea);

            textarea.select();
            const ok = document.execCommand('copy');

            document.body.removeChild(textarea);

            if (!ok) throw new Error("copy failed");

            return markCopied();
        } catch (e) {
            error.value = 'Failed to copy';
            copied.value = false;
            return false;
        }
    };

    const markCopied = () => {
        copied.value = true;
        error.value = null;
        setTimeout(() => (copied.value = false), 2000);
        return true;
    };

    return { copied, error, copyToClipboard };
}
